export default __webpack_public_path__ + "static/media/warren1.7df4ff47.png";